import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateStrategicAxisRequestFailure() {
      return getState().isFailure;
    },
    isCreateStrategicAxisRequestPending() {
      return getState().isPending;
    },
    isCreateStrategicAxisRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
